export enum MSFavouriteFilterValues {
  All = "All",
  Favourites = "Favourites",
}

export enum MSSelectedFilterValues {
  All = "All",
  Selected = "Selected",
}

export enum MSFilterItemSize {
  Small = "small",
  Medium = "medium",
}

export enum MSFilterSwitchValues {
  Each = "each",
  Any = "any",
  Not = "not"
}

export enum MSFilterFavouriteSwitchValues {
  All = "all",
  Favourites = "favourites",
}
